import React, { useState, useEffect, useRef } from 'react'
import { loaderStateTrue, loaderStateFalse } from '../../Actions/AllAction';
import { setUserCredentials } from '../../GlobalModules/Login/Actions/LoginAction';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

function SkeletonThemeContentGroupList(props) {


    return (
        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                    <div className='container'>
                        <SkeletonTheme baseColor="#f3f3f3" highlightColor="#ebebeb">
                            <div className='skeleton-animation-section'>
                                <div className='sectionTitleBox'>
                                    <Skeleton width="100%" height={20} borderRadius={0} />
                                </div>
                                <div className='sectionTitleDecBox'>
                                    <Skeleton width="100%" height={15} borderRadius={0} />
                                </div>
                                <div className='hotel-list-row exploreImg exploreGroupTour'>
                                    <div className='hotel-list-img-box'>
                                        <Skeleton width="100%" height={224} />
                                    </div>
                                    <div className='hotel-list-img-box'>
                                        <Skeleton width="100%" height={224} />
                                    </div>
                                    <div className='hotel-list-img-box'>
                                        <Skeleton width="100%" height={224} />
                                    </div>
                                    <div className='hotel-list-img-box'>
                                        <Skeleton width="100%" height={224} />
                                    </div>  
                                </div>
                            </div>
                        </SkeletonTheme>
                    </div>
                </div>
    );
}

SkeletonThemeContentGroupList.defaultProps = {

}

const mapStateToProps = (globalState) => {
    return {
        userCredentials: globalState.LoginReducer.userCredentials
    };
}

export default connect(mapStateToProps, { loaderStateTrue, loaderStateFalse, setUserCredentials })(withRouter(SkeletonThemeContentGroupList));